import { motion, useReducedMotion } from "framer-motion";
import { EASE } from "../lib/motion";

const LEVERS = [
  {
    num: "01",
    title: "Rebuild the framework.",
    sub: "from dogmatic to pragmatic",
    desc: "Combine TBM, FinOps, and ITIL into one living, adaptive architecture. Stop implementing frameworks. Start designing systems that learn.",
  },
  {
    num: "02",
    title: "Tear down the silos.",
    sub: "integrated & trust-based",
    desc: "Unite IT, Finance, and Business around shared data and shared accountability. Trust replaces control. Governance becomes guidance.",
  },
  {
    num: "03",
    title: "Steer by value.",
    sub: "EBIT-focused",
    desc: "Connect every euro of tech spend to revenue, margin, or innovation. Steer by EBIT and outcomes. You can't save your way into the future.",
  },
  {
    num: "04",
    title: "Connected systems.",
    sub: "open & accessible",
    desc: "Build an open, connected environment where data and decisions flow. ITFM stops being a reporting function and becomes the intelligence layer of the modern enterprise.",
  },
  {
    num: "05",
    title: "Amplify AI.",
    sub: "agentic & human-driven",
    desc: "AI and humans in concert. Machines bring speed. Practitioners bring sense. Faster, smarter, more meaningful decisions. Neither alone delivers.",
  },
];

export const HowWeWork = () => {
  const reduce = useReducedMotion();
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.1, delayChildren: 0.2 } },
  };
  const item = {
    hidden: { opacity: 0, ...(reduce ? {} : { y: 20 }) },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
  };

  return (
    <section className="evc-hww" data-testid="evc-how-we-work">
      <div className="evc-hww-wrap">
        <motion.div
          className="evc-hww-head"
          initial={{ opacity: 0, ...(reduce ? {} : { y: 16 }) }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: EASE }}
        >
          <div>
            <span className="evc-hww-eyebrow">01 &nbsp;·&nbsp; How we work</span>
            <h2 className="evc-hww-h2">Five levers.<br />One principle.</h2>
          </div>
          <p className="evc-hww-intro">
            Modern ITFM isn't a framework you adopt. It's five shifts you make. Every question, every
            score, every recommendation traces back to one of them. The point isn't to rank you - it's
            to show you which lever is the one to pull next.
          </p>
        </motion.div>
        <motion.div
          className="evc-hww-grid"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
        >
          {LEVERS.map((l) => (
            <motion.div className="evc-hww-cell" key={l.num} variants={item} data-testid={`evc-lever-${l.num}`}>
              <div className="evc-hww-num">{l.num}</div>
              <div className="evc-hww-title">{l.title}</div>
              <div className="evc-hww-sub">{l.sub}</div>
              <div className="evc-hww-desc">{l.desc}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
